import React from "react";

export interface SlideLayoutProps {
  use: React.FC<{ children?: React.ReactNode }>;
}

export const Notes: React.FC = () => null;
export const Continue: React.FC = () => null;
export const SlideLayout: React.FC<SlideLayoutProps> = () => null;
